//  M M M M                       M M M M          O O O O O O O O           ! ! ! ! ! !
//  M M M M M                   M M M M M        O O O O O O O O O O         ! ! ! ! ! !
//  M M M M M M               M M M M M M      O O O O O O O O O O O O        ! ! ! ! !
//  M M M M M M M           M M M M M M M      O O O O         O O O O        ! ! ! ! !
//  M M M M M M M M       M M M M M M M M    O O O O             O O O O       ! ! ! !
//  M M M M M M M M M   M M M M M M M M M    O O O O             O O O O       ! ! ! !
//  M M M M   M M M M M M M M M   M M M M    O O O O             O O O O        ! ! !
//  M M M M     M M M M M M M     M M M M    O O O O             O O O O        ! ! !
//  M M M M       M M M M M       M M M M    O O O O             O O O O         ! !
//  M M M M         M M M         M M M M    O O O O             O O O O          !
//  M M M M           M           M M M M      O O O O         O O O O
//  M M M M                       M M M M      O O O O O O O O O O O O          ! ! !         
//  M M M M                       M M M M        O O O O O O O O O O          ! ! ! ! !
//  M M M M                       M M M M          O O O O O O O O              ! ! !


// Backbone.MultiSelect v0.2
// (c) 2013 Mohamed Rachidi 
// Distributed Under MIT License
(function(_, Backbone) {
    Backbone.MultiSelect = {};

    function throwError(message, name) {
        var error = new Error(message);
        error.name = name || 'Error';
        throw error;
    }


    if (!Backbone || !_) {
        throwError('Please include Backbone.js and underscore.js before Backbone.MultiSelect');
    }

    Backbone.MultiSelect.VERSION = '0.2';

    // Trigger an event and/or a corresponding method name. Examples:
    //
    // `this.triggerMethod("foo")` will trigger the "foo" event and
    // call the "onFoo" method.
    //
    // `this.triggerMethod("foo:bar") will trigger the "foo:bar" event and
    // call the "onFooBar" method.
    Backbone.MultiSelect.triggerMethod = (function() {

        // split the event name on the :
        var splitter = /(^|:)(\w)/gi;

        // take the event section ("section1:section2:section3")
        // and turn it in to uppercase name

        function getEventName(match, prefix, eventName) {
            return eventName.toUpperCase();
        }

        // actual triggerMethod name
        var triggerMethod = function(event) {
            // get the method name from the event name
            var methodName = 'on' + event.replace(splitter, getEventName);
            var method = this[methodName];

            // trigger the event, if a trigger method exists
            if (_.isFunction(this.trigger)) {
                this.trigger.apply(this, arguments);
            }

            // call the onMethodName if it exists
            if (_.isFunction(method)) {
                // pass all arguments, except the event name
                return method.apply(this, _.tail(arguments));
            }
        };

        return triggerMethod;
    })();

    Backbone.MultiSelect.Selectable = function(model) {
        var _this = this;
        if (!model) {
            throwError("A view and model must be defined");
        }
        this.model = model;
        this.selected = false;
        this.model._selectable = this;
        var publicMethods = this.getPublicMethods();
        for (var i = publicMethods.length - 1; i >= 0; i--) {
            var method = publicMethods[i];
            this.model[method] = _.bind(this[method], this);
        }
    };
    _.extend(Backbone.MultiSelect.Selectable.prototype, {
        select: function(options) {
            if (this.selected) {
                return;
            }
            options = options || {};
            this.selected = true;
            if (!options.silent) {
                this.model.trigger("selected", this.model);
            }
            if (this.model.collection && this.model.collection._multiSelect) {
                this.model.collection._multiSelect.select(this.model);
            }
        },
        unSelect: function(options) {
            if (!this.selected) {
                return;
            }
            options = options || {};
            this.selected = false;
            if (!options.silent) {
                this.model.trigger("unSelected", this.model);
            }
            if (this.model.collection && this.model.collection._multiSelect) {
                this.model.collection._multiSelect.unSelect(this.model);
            }
        },
        toggleSelect: function(options) {
            if (this.selected) {
                this.unSelect(options);
            } else {
                this.select(options);
            }
        },
        isSelected: function() {
            return this.selected;
        },
        getPublicMethods: function() {
            return ["select", "unSelect", "toggleSelect", "isSelected"];
        }
    });

    Backbone.MultiSelect.SingleSelect = function(collection) {
        var _this = this;
        if (!collection) {
            throwError("A view and collection must be defined");
        }
        this.collection = collection;
        this.selectedElement = null;
        collection._multiSelect = this;
        this.collection.on("remove", function(item) {
            item.unSelect();
        });
        var publicMethods = this.getPublicMethods();
        for (var i = publicMethods.length - 1; i >= 0; i--) {
            var method = publicMethods[i];
            this.collection[method] = _.bind(this[method], this);
        }
    };
    _.extend(Backbone.MultiSelect.SingleSelect.prototype, {
        select: function(model, options) {
            if (model && this.selectedElement === model && this.collection.get(model)) {
                return;
            }
            options = options || {};
            this.unSelect();
            this.selectedElement = model;
            this.selectedElement.select(options);
            if (!options.silent) {
                this.collection.trigger("select:one", model);
            }
        },
        unSelect: function(model, options) {
            if (!this.selectedElement) {
                return;
            }
            options = options || {};
            model = model || this.selectedElement;
            if (this.selectedElement !== model) {
                return;
            }
            model.unSelect(options);
            if (!options.silent) {
                this.collection.trigger("un:select:one", model);
            }
            delete this.selectedElement;
        },
        getSelectedElement: function() {
            return _.filter(this.models, function(model) {
                return model.isSelected();
            });
        },
        getPublicMethods: function() {
            return ["select", "unSelect", "getSelectedElement"];
        }
    });

    Backbone.MultiSelect.MultipleSelect = function(collection) {
        var _this = this;
        if (!collection) {
            throwError("A view and collection must be defined");
        }
        this.collection = collection;
        //cid of all the elements selected
        this.selectedElements = {};
        collection._multiSelect = this;
        this.collection.on("remove", function(item) {
            item.unSelect();
        });
        var publicMethods = this.getPublicMethods();
        for (var i = publicMethods.length - 1; i >= 0; i--) {
            var method = publicMethods[i];
            this.collection[method] = _.bind(this[method], this);
        }
    };
    _.extend(Backbone.MultiSelect.MultipleSelect.prototype, {
        select: function(model, options) {
            if (model && this.selectedElements[model.cid] && this.collection.get(model)) {
                return;
            }
            this.selectedElements[model.cid] = model;
            model.select(options);
            calculateSelectedLength(this.collection, options);
        },
        unSelect: function(model, options) {
            if (model && !this.selectedElements[model.cid] && this.collection.get(model)) {
                return;
            }
            delete this.selectedElements[model.cid];
            model.unSelect(options);
            calculateSelectedLength(this.collection, options);
        },
        selectAll: function(options) {
            this.collection.each(function(model) {
                model.select(options);
            });
            calculateSelectedLength(this.collection, options);
        },
        unSelectAll: function(options) {
            if (this.selectedLength === 0) {
                return;
            }
            this.collection.each(function(model) {
                model.unSelect(options);
            });
            calculateSelectedLength(this.collection, options);
        },
        toggleSelectAll: function(options) {
            if (this.selectedLength === this.collection.length) {
                this.unSelectAll(options);
            } else {
                this.selectAll(options);
            }
        },
        getSelectedElements: function() {
            return _.filter(this.collection.models, function(model) {
                return model.isSelected();
            });
        },
        hasSelectedElements: function() {
            return _.filter(this.collection.models, function(model) {
                return model.isSelected();
            }).length;
        },
        getPublicMethods: function() {
            return ["select", "unSelect", "unSelectAll", "selectAll", "toggleSelectAll", "getSelectedElements", "hasSelectedElements"];
        }
    });

    var calculateSelectedLength = function(collection, options) {
        options = options || {};
        collection._multiSelect.selectedLength = _.size(collection._multiSelect.selectedElements);

        var selectedLength = collection._multiSelect.selectedLength;
        var length = collection.length;

        if (selectedLength > 0 && selectedLength === length) {
            if (!options.silent) {
                collection.trigger("select:all", collection.models);
            }
            return;
        }

        if (selectedLength === 0) {
            if (!options.silent) {
                collection.trigger("un:select:all");
            }
            return;
        }

        if (selectedLength > 0 && selectedLength < length) {
            var selectedModels = _.filter(collection.models, function(model) {
                return model.selected === true;
            });
            if (!options.silent) {
                collection.trigger("select:some", selectedModels);
            }
            return;
        }
    };
})(_, Backbone);